<mat-toolbar color="primary" class="global-header">
    <mat-toolbar-row>
        <button matButton [matMenuTriggerFor]="beforeMenu" class="dropdown-btn">
            <span class="dropdown-btn_label">
                <img class="icon-user" src="./assets/images/user.svg" />
                <span class="icon icon-arrow-down"></span>
            </span>
        </button>
        <mat-menu class="menu-dropdown" #beforeMenu="matMenu" xPosition="before">
            <button mat-menu-item (click)="goToProfile()">
                {{ 'profile' | translate }}
            </button>
            <button mat-menu-item (click)="logout()">
                {{ 'logout' | translate }}
            </button>
        </mat-menu>
    </mat-toolbar-row>
</mat-toolbar>
